import { Space, Container } from "@mantine/core";
import React from "react";
import { useSelector } from "react-redux";
import Account from "../../components/account/account";
import { AccountCommander } from "../../store/commanders/account.commander";
import "./account.scss";
import { PrintableCertificate } from "../../components/certficate/certificate";
import { formatCertificateDate } from "../../helpers/date.helper";
import { useTranslation } from "react-i18next";

export default function AccountPage() {
  const { t } = useTranslation();
  const userData = useSelector((state: any) => state.account.userData);
  const userCourseSession = useSelector((state: any) => state.course.data);

  const onEditHandler = (data) => {
    AccountCommander.cmd_update_account({ ...userData, ...data });
  };

  const userName = `${userData.first_name || ""} ${userData.last_name || ""}`.trim();

  return (
    <Container size={"xl"} className="u-w-100">
      <PrintableCertificate
        courseStatus={userCourseSession.status}
        userName={userName}
        state={userData.state}
        completedDate={formatCertificateDate(userCourseSession.last_completion)}
        className="print-certificate-button cf-navbar__links--link cf-navbar__links--link-primary"
      />

      <Space h="md" />

      <Account
        data={userData}
        onEditHandler={onEditHandler}
        label={t("account.updateInformation")}
      />
    </Container>
  );
}
